import { render, staticRenderFns } from "./CommonApprovalDialog.vue?vue&type=template&id=8bb94b56"
import script from "./CommonApprovalDialog.vue?vue&type=script&lang=js"
export * from "./CommonApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonApprovalDialog.vue?vue&type=style&index=0&id=8bb94b56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports